import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {CountryLevelPartnerReportBase} from './CountryLevelPartnerReportBase';

function GameRevenueOverviewInner() {
    return <CountryLevelPartnerReportBase tabId="GameRevenueOverview" />;
}

export const GameRevenueOverview = withTraceErrorBoundary(GameRevenueOverviewInner, ErrorModal);
